export enum BillOfMaterialsStatus {
  Active = "active",
  Inactive = "inactive",
  Draft = "draft",
}
